module.exports = __webpack_public_path__ + "static/media/item_bgp.e321c1cf.png";